import { render, staticRenderFns } from "./Sped-BlocoK.vue?vue&type=template&id=28889532&"
import script from "./Sped-BlocoK.vue?vue&type=script&lang=js&"
export * from "./Sped-BlocoK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sped-BlocoK.vue"
export default component.exports